import { Identifiable, Project, WbsMeta } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    gantt: WbsMeta[string][];
  };
};

function getWbsMeta(httpClient: HttpClient) {
  return (projects: Identifiable<Project>[]) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/gantt`,
        method: HttpMethods.POST,
        data: {
          pageNumber: 0,
          pageSize: 99999,
          elementScope: "PROJECT",
          sortType: "KEY_RANK",
          order: "ASC",
          projectUuids: projects.map(({ uuid }) => uuid),
          shows: ["ACTIVITY", "TASK", "MILESTONE", "EVENT", "COMPLETED_WORK"],
          type: "TOTALS",
          includeTemplates: !!projects.find((project) => project.isTemplate),
        },
      })
      .then(({ _embedded: { gantt } }) =>
        gantt.reduce<WbsMeta>(
          (meta, chunk) => ({ ...meta, [chunk.uuid]: chunk }),
          {},
        ),
      );
}

export { getWbsMeta };
